'use strict';

var _module2 = require('./module');

var _module3 = _interopRequireDefault(_module2);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

_module3.default.directive('genderSelect', [function () {
    return {
        restrict: "E",
        template: require('./genderSelect.html'),
        require: 'ngModel',
        scope: {},
        link: function link($scope, element, attrs, ngModel) {
            ngModel.$render = function () {
                $scope.value = ngModel.$viewValue;
            };

            attrs.$observe('emptyLabel', function (value) {
                $scope.emptyLabel = value;
            });

            $scope.$watch('value', function () {
                ngModel.$setViewValue($scope.value);
                ngModel.$render();
                //ngModel.$setValidity('required', !attrs.required || !!$scope.value);
            });

            ngModel.$validators.required = function (modelValue, viewValue) {
                return !attrs.required || !!modelValue && modelValue !== 'CH';
            };

            var allowAdults = true;
            var allowChildren = false;
            var allowChildrenGender = false;
            var allowInfants = false;

            function rebuildGenders() {
                $scope.genders = [];

                if (allowAdults != null && allowAdults === 'false') {
                    allowAdults = false;
                }
                if (allowChildren != null && allowChildren === 'false') {
                    allowChildren = false;
                }
                if (allowChildrenGender != null && allowChildrenGender === 'false') {
                    allowChildrenGender = false;
                }
                if (allowInfants != null && allowInfants === 'false') {
                    allowInfants = false;
                }

                if (allowAdults) {
                    // $scope.genders = [
                    //   { Key: 'MR', Name: 'common.gender_mr' },
                    //   { Key: 'MS', Name: 'common.gender_ms' }
                    // ];
                    $scope.genders.push({ Key: 'MR', Name: 'common.gender_mr' });
                    $scope.genders.push({ Key: 'MS', Name: 'common.gender_ms' });
                }

                if (allowChildren) {
                    if (allowChildrenGender) {
                        if (allowAdults) {
                            $scope.genders.push({ Key: 'CH/M', Name: 'common.gender_chm' });
                            $scope.genders.push({ Key: 'CH/F', Name: 'common.gender_chf' });
                        } else {
                            $scope.genders.push({ Key: 'CH/M', Name: 'common.gender_mr' });
                            $scope.genders.push({ Key: 'CH/F', Name: 'common.gender_ms' });
                        }
                    } else {
                        $scope.genders.push({ Key: 'CH', Name: 'common.gender_ch' });
                    }
                }
                if (allowInfants) {
                    $scope.genders.push({ Key: 'IN', Name: 'common.gender_in' });
                }
            }

            rebuildGenders();

            attrs.$observe('children', function (value) {
                allowChildren = value;
                rebuildGenders();
            });

            attrs.$observe('childGender', function (value) {
                allowChildrenGender = value;
                rebuildGenders();
            });

            attrs.$observe('infants', function (value) {
                allowInfants = value;
                rebuildGenders();
            });

            attrs.$observe('ppdisable', function (value) {
                $scope.ppdisable = value;
            });

            attrs.$observe('noAdults', function (value) {
                if (!value) allowAdults = true;else allowAdults = !(value == 'true');
                rebuildGenders();
            });
        }
    };
}]);


//////////////////
// WEBPACK FOOTER
// ./src/core/genderSelect.js
// module id = 62
// module chunks = 0 2